import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({ preference: 'system', resolvedTheme: 'light', setPreference: () => {} });
const valid = value => ['system', 'light', 'dark'].includes(value);
export function ThemeProvider({ children }) {
  const [preference, updatePreference] = useState(() => {
    try { const saved = localStorage.getItem('rayat-theme'); return valid(saved) ? saved : 'system'; }
    catch { return 'system'; }
  });
  const [systemDark, setSystemDark] = useState(() => window.matchMedia?.('(prefers-color-scheme: dark)').matches || false);
  const resolvedTheme = preference === 'system' ? (systemDark ? 'dark' : 'light') : preference;
  useEffect(() => {
    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    if (!media) return undefined;
    const changed = event => setSystemDark(event.matches);
    media.addEventListener?.('change', changed);
    return () => media.removeEventListener?.('change', changed);
  }, []);
  useEffect(() => {
    document.documentElement.classList.toggle('dark', resolvedTheme === 'dark');
    document.documentElement.dataset.theme = resolvedTheme;
    document.documentElement.style.colorScheme = resolvedTheme;
  }, [resolvedTheme]);
  const setPreference = value => {
    if (!valid(value)) return;
    updatePreference(value);
    try { localStorage.setItem('rayat-theme', value); } catch { /* Session-only if storage is unavailable. */ }
  };
  return <ThemeContext.Provider value={{preference, resolvedTheme, setPreference}}>{children}</ThemeContext.Provider>;
}
export const useTheme = () => useContext(ThemeContext);
